import { computed, defineComponent } from '@vue/composition-api';
import SearchBar from '@/Search/components/SearchBar.vue';
import { imageSrcSet, imageUrl } from '@/util/images';
const HERO_FALLBACK = '/img/brand/hero.jpg';
export default defineComponent({
    components: { SearchBar },
    props: {
        blok: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, context) {
        const { root } = context;
        const t = (key) => root.$i18n.t(key);
        const source = computed(() => props.blok?.hero_image?.filename || HERO_FALLBACK);
        return {
            eyebrow: computed(() => props.blok?.eyebrow || t('home.q4s.hero.eyebrow')),
            title: computed(() => props.blok?.title || t('home.q4s.hero.title')),
            titleAccent: computed(() => props.blok?.title_accent || t('home.q4s.hero.title_accent')),
            lead: computed(() => props.blok?.lead || t('home.q4s.hero.lead')),
            imageSrc: computed(() => imageUrl(source.value, { width: 1600, height: 900, crop: 'c-at_least' })),
            imageSet: computed(() => imageSrcSet(source.value, [640, 960, 1280, 1920], {
                aspect: 16 / 9,
                crop: 'c-at_least'
            }))
        };
    }
});
